export default __webpack_public_path__ + "static/media/shield-red.d5d0f777.svg";